import TrackServicesIndex from "@/components/TrackServicesIndex";
import { COMMERCIAL_SERVICES_DATA } from "@/data/commercial-services";
import { PAGE_META } from "@/lib/seo-constants";

export default function CommercialServices() {
    return (
        <TrackServicesIndex
            trackKey="commercial"
            servicesData={COMMERCIAL_SERVICES_DATA}
            meta={PAGE_META.commercialServices}
            intro={{
                title: "Commercial exterior & property services.",
                body: "Insured, scheduled, COI-ready work across your portfolio — from parking lots and walkways to fencing, masonry restoration, hardscape and grounds.",
            }}
        />
    );
}
